module.exports = __webpack_public_path__ + "img/all.e28eaa74.jpg";